import React from 'react';
import { useNavigate } from 'react-router-dom';
import IdleScreen from '../components/IdleScreen';
import { useApp } from '../context/AppContext';

const IdlePage = () => {
  const navigate = useNavigate();
  const { resetIdleTime } = useApp();

  const handleIdleInteraction = () => {
    // Resetar o temporizador de inatividade e navegar para o check-in
    resetIdleTime();
    navigate('/check-in');
  };

  return <IdleScreen onInteraction={handleIdleInteraction} />;
};

export default IdlePage;
